import React, { useCallback, useEffect } from 'react';
import PropTypes from 'prop-types';
import { each } from 'lodash';
import { Grid } from '@material-ui/core';
import TextInputFieldWithValidation from '../../ValidationFormElements/TextInputFieldWithValidation';

const OtherLegalApplicantForm = ({
  formProps,
  valueNames = {},
  initialData,
}) => {
  const { hvhh, organizationName, email, phone } = valueNames;
  const { register, errors, clearError, triggerValidation, setValue } = formProps;

  useEffect(() => {
    const keys = [email, hvhh, organizationName, phone];
    each(keys, (value) => {
      if (initialData[value]) {
        setValue(value, initialData[value], !!initialData[value]);
      }
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [setValue, email, hvhh, organizationName, phone]);

  const triggerPhonesValidation = useCallback(() => {
    if (errors.phone) {
      triggerValidation({ name: 'phone' });
    }
    if (errors.cellPhone) {
      triggerValidation({ name: 'cellPhone' });
    }
  }, [errors.cellPhone, errors.phone, triggerValidation]);
  return (
    <Grid container spacing={4}>
      <Grid item md={6} xs={12}>
        <TextInputFieldWithValidation
          formProps={{ errors, clearError }}
          name={hvhh}
          autoComplete="off"
          register={register}
          labelKey="propertyClaim.personalData.hvhh"
          required
        />
      </Grid>
      <Grid item md={6} xs={12}>
        <TextInputFieldWithValidation
          formProps={{ errors, clearError }}
          name={organizationName}
          autoComplete="off"
          register={register}
          labelKey="propertyClaim.personalData.name"
          required
        />
      </Grid>
      <Grid item md={6} xs={12}>
        <TextInputFieldWithValidation
          formProps={{ errors, clearError }}
          name={email}
          autoComplete="off"
          register={register}
          labelKey="claim.conclusion.email"
          required
        />
      </Grid>
      <Grid item md={6} xs={12}>
        <TextInputFieldWithValidation
          formProps={{ errors, clearError }}
          name={phone}
          autoComplete="off"
          register={register}
          type="tel"
          labelKey="claim.conclusion.cellPhone"
          required
          handleChange={triggerPhonesValidation}
        />
      </Grid>
    </Grid>
  );
};

OtherLegalApplicantForm.propTypes = {
  formProps: PropTypes.shape({
    register: PropTypes.func,
    setValue: PropTypes.func,
    errors: PropTypes.shape({
      phone: PropTypes.string,
      cellPhone: PropTypes.string,
    }),
    clearError: PropTypes.func,
    triggerValidation: PropTypes.func,
  }).isRequired,
  valueNames: PropTypes.shape({
    hvhh: PropTypes.string,
    organizationName: PropTypes.string,
    email: PropTypes.string,
    phone: PropTypes.string,
  }).isRequired,
  initialData: PropTypes.shape({}).isRequired,
};

export default OtherLegalApplicantForm;
